import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryArchiveFailedAction = {
	type: 'BENEFICIARY_ARCHIVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryArchiveFailedAction => ({
	type: 'BENEFICIARY_ARCHIVE_FAILED',
	payload,
});
